import React, { Component } from 'react';
import Button, { BUTTON_COLORS } from 'components/Button';
import PropTypes from 'prop-types';

function checkUrlForRedirect(url) {
  return url.includes('myTaxes/payment/bank');
}

export default class ErrorPage extends Component {
  static defaultProps = {
    title: 'Функционал недоступен',
    message: 'В данный момент функционал недоступен',
    backPage: '',
  };

  render() {
    const { backPage, message, title } = this.props;
    const backStep = checkUrlForRedirect(backPage) ? -2 : -1;
    return (
      <div>
        <h1 className={'white-block__pad30'}>{title}</h1>
        <div className={'white-block'}>
          <div className={'white-block__pad30'}>{message}</div>
          <div className="white-block__pad30">
            <Button
              color={BUTTON_COLORS.BLUE}
              onClick={() => {
                window.history.go(backStep);
              }}
            >
              Назад
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  backPage: PropTypes.string,
};
